import React from "react";
import { withTranslation } from "react-i18next";
import CONFIG_OBJECT from "../../../config/config";
import DC_Constants from "../DC_Constants";
import "./drop-down.css";
// import CustomDropDown from '../drop-down-component/CustomDropDown';

class DiaperLandingData extends React.Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    // this.setWrapperRef = this.setWrapperRef.bind(this);
  }
  state = {
    numOfGuests: "",
    pkgPerPerson: "",
    defaultGuests: "",
    defaultpkgPerPerson: "",
    weight: "",
    period: "",
    eventListOptions: [],
    eventDefaultValue: this.props.componentData.eventDropDownDefaultText.value,
    showTripForm: false,
    showTeaPartyForm: false,
    showTripErrorLabel: false,
    showItems: false,
    selectedItem: {
      value: this.props.componentData.eventDropDownDefaultText.value,
      id: 1,
    },
    arrowClicked: false,
    weightUnitKgs: true,

    lbsguid: this.props.componentData.weightUnits[1].id,
    kgsguid: this.props.componentData.weightUnits[0].id,
  };
  onToggle = () => {
    this.state.weightUnitKgs = this.state.weightUnitKgs ? false : true;

    this.state.weight = "";
  };
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    this.setState(
      (prevState, props) => {
        return {
          eventListOptions: props.componentData.eventDropDownList,
        };
      },
      () => {
        this.props.sendLastPeriodData(
          this.state.eventDefaultValue,
          this.state.numOfGuests,
          this.state.pkgPerPerson,
          this.state.weight,
          this.state.period,
          this.state.weightUnitKgs,
          this.state.lbsguid,
          this.state.kgsguid
        );
      }
    );
  }

  mouseClicked = (e) => {
    if (this.state.showItems) {
      this.setState({
        showItems: false,
      });
    }
  };

  componentDidUpdate(nextProps) {
    if (nextProps.isReset !== this.props.isReset) {
      this.setState({
        numOfGuests: "",
        pkgPerPerson: "",
        weight: "",
        period: "",
      });
    }
  }

  handleClickOutside = (event) => {
    console.log(event.target.className);
    if (
      event.target.className === "select-box--selected-item" &&
      document.getElementsByClassName("select-box--arrow-down")[0] !== undefined
    ) {
      this.setState({
        showItems: true,
      });
    } else if (event.target.className === "select-box--arrow-down") {
      this.setState({
        showItems: false,
      });
    } else if (event.target.className === "select-box--arrow-up") {
      this.setState({
        showItems: true,
      });
    } else {
      this.setState({
        showItems: false,
      });
    }
  };
  dropDown = () => {
    this.setState((prevState) => ({
      showItems: !prevState.showItems,
      arrowClicked: prevState.showItems,
    }));
    // console.log(this.state.arrowClicked + '*************************')
  };

  closeDropDown = () => {
    this.setState({
      showItems: false,
    });
  };

  selectItem = (item) => {
    // if(item.value === this.state.selectedItem.value){
    //     this.setState({
    //         selectedItem: item,
    //         showItems: false,
    //         showTripForm: item.value === 'Trip',
    //         showTeaPartyForm: item.value !== 'Trip',
    //         weight: this.state.weight,
    //         period: this.state.period,
    //         numOfGuests: this.state.numOfGuests,
    //         pkgPerPerson: this.state.pkgPerPerson,
    //         eventDefaultValue: item.value
    //     })
    // }
    if (item.value === "Select the type of event") {
      this.setState({
        selectedItem: item,
        showItems: false,
        showTripForm: false,
        showTeaPartyForm: false,
        eventDefaultValue: item.value,
      });
    } else {
      this.setState({
        selectedItem: item,
        showItems: false,
        showTripForm: item.value === "Trip",
        showTeaPartyForm: item.value !== "Trip",
        weight: "",
        period: "",
        numOfGuests: "",
        pkgPerPerson: "",
        eventDefaultValue: item.value,
      });
    }

    this.props.sendLastPeriodData(
      item.value,
      this.state.numOfGuests,
      this.state.pkgPerPerson,
      this.state.weight,
      this.state.period,
      item.value,
      this.state.weightUnitKgs,

      this.state.lbsguid,
      this.state.kgsguid
    );
  };

  // This method is to validate the values in the input box
  validatePeriodValue = (event) => {
    if (
      event.target.value !== "" &&
      event.target.value !== 0 &&
      event.target.value < 0
    ) {
      event.target.value = 1;
    } else if (
      event.target.value !== "" &&
      event.target.value !== 0 &&
      event.target.value >
        Number(this.props.t("DiaperCalculator_NoOfDaysMaxValue"))
    ) {
      event.target.value = Number(
        this.props.t("DiaperCalculator_NoOfDaysMaxValue")
      );
    } else if (event.target.value == "") {
      event.target.value = event.target.value;
    } else if (event.target.value == 0) {
      event.target.value = 1;
    } else {
      event.target.value =
        event.target.name === "weight"
          ? event.target.value
          : Math.round(event.target.value);
    }

    if (event.target.name === "period") {
      this.setState({
        period: event.target.value,
      });

      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(this.state.numOfGuests),
        Number(this.state.pkgPerPerson),
        Number(this.state.weight),
        Number(event.target.value),
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
    }
  };

  // This method is to validate the values in the input box
  validateValue = (event) => {
    let maxValue = 0;
    switch (event.target.name) {
      case "weight": {
        maxValue = Number(this.props.t("DiaperCalculator_BabyWeightMaxValue"));
        break;
      }
      case "number-of-guests": {
        maxValue = Number(this.props.t("DiaperCalculator_NoOfGuestsMaxValue"));
        break;
      }
      case "pkg-per-person": {
        maxValue = Number(
          this.props.t("DiaperCalculator_PackagesPerPersonMaxValue")
        );
        break;
      }
    }

    if (event.target.value == ".") event.target.value = 1;
    if (
      event.target.value !== "" &&
      event.target.value !== 0 &&
      event.target.value < 0
    ) {
      event.target.value = 1;
    } else if (
      event.target.value !== "" &&
      event.target.value !== 0 &&
      event.target.value > maxValue
    ) {
      event.target.value = maxValue;
    } else if (event.target.value == "") {
      event.target.value = event.target.value;
    } else if (event.target.value == 0) {
      // if (event.target.name !== 'weight') {
      event.target.value = 1;
      // }
    }
    // else if (event.target.name === 'weight' && Number(event.target.value) < 1) {
    //     event.target.value = 1
    // }
    else {
      event.target.value =
        event.target.name === "weight"
          ? event.target.value
          : Math.round(event.target.value);
    }

    if (event.target.name === "number-of-guests") {
      this.setState({
        numOfGuests: event.target.value,
        defaultGuests: event.target.value,
      });
      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(event.target.value),
        Number(this.state.pkgPerPerson),
        Number(this.state.weight),
        Number(this.state.period),
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
      // document.getElementsByName('number-of-guests')[0].blur()
    } else if (event.target.name === "pkg-per-person") {
      this.setState({
        pkgPerPerson: event.target.value,
        defaultpkgPerPerson: event.target.value,
      });
      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(this.state.numOfGuests),
        Number(event.target.value),
        Number(this.state.weight),
        Number(this.state.period),
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
      // document.getElementsByName('pkg-per-person')[0].blur()
    } else if (event.target.name === "weight") {
      this.setState({
        weight: event.target.value,
      });
      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(this.state.numOfGuests),
        Number(this.state.pkgPerPerson),
        Number(event.target.value),
        Number(this.state.period),
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
    }
  };
  preventEvent = (e) => {
    e.preventDefault();
  };

  handleChange = (event) => {
    if (event.target.value === "Select the type of event") {
      this.setState({
        eventDefaultValue: event.target.value,
        showTripForm: false,
        showTeaPartyForm: false,
      });
      this.props.sendLastPeriodData(
        event.target.value,
        this.state.numOfGuests,
        this.state.pkgPerPerson,
        this.state.weight,
        this.state.period,
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
      //document.getElementById("calculate-button-id").disabled = true;
    }
    if (event.target.value === "Trip") {
      this.setState({
        eventDefaultValue: event.target.value,
        showTripForm: true,
        showTeaPartyForm: false,
        weight: "",
        period: "",
      });

      this.props.sendLastPeriodData(
        event.target.value,
        this.state.numOfGuests,
        this.state.pkgPerPerson,
        this.state.weight,
        this.state.period,
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
      //document.getElementById("calculate-button-id").disabled = true;
    } else if (event.target.value === "Baby Shower Tea Party") {
      this.setState({
        eventDefaultValue: event.target.value,
        showTeaPartyForm: true,
        showTripForm: false,
        numOfGuests: "",
        pkgPerPerson: "",
      });
      this.props.sendLastPeriodData(
        event.target.value,
        this.state.numOfGuests,
        this.state.pkgPerPerson,
        this.state.weight,
        this.state.period,
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
      //document.getElementById("calculate-button-id").disabled = true;
    } else if (event.target.name === "number-of-guests") {
      this.setState({
        numOfGuests: event.target.value,
        defaultGuests: event.target.value,
      });
      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(event.target.value),
        Number(this.state.pkgPerPerson),
        Number(this.state.weight),
        Number(this.state.period),
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
    } else if (event.target.name === "pkg-per-person") {
      this.setState({
        pkgPerPerson: event.target.value,
        defaultpkgPerPerson: event.target.value,
      });
      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(this.state.numOfGuests),
        Number(event.target.value),
        Number(this.state.weight),
        Number(this.state.period),
        event.target.value
      );
    } else if (event.target.name === "weight") {
      this.setState({
        weight: event.target.value,
      });
      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(this.state.numOfGuests),
        Number(this.state.pkgPerPerson),
        Number(event.target.value),
        Number(this.state.period),
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
    } else if (event.target.name === "period") {
      this.setState({
        showTripErrorLabel:
          event.target.value >
          this.props.t("DiaperCalculator_NoOfDaysMaxValue"),
        period: event.target.value,
      });
      // sending data from here to ParentComponent
      this.props.sendLastPeriodData(
        this.state.eventDefaultValue,
        Number(this.state.numOfGuests),
        Number(this.state.pkgPerPerson),
        Number(this.state.weight),
        Number(event.target.value),
        event.target.value,
        this.state.weightUnitKgs,
        this.state.lbsguid,
        this.state.kgsguid
      );
    }
  };

  // This function check text box having only numbers or decimal
  checkNumberOnly = (e) => {
    var key = e.keyCode ? e.keyCode : e.which;
    if (
      key === 13 &&
      this.state.eventDefaultValue === DC_Constants.BABY_SHOWER
    ) {
      document.getElementsByName("number-of-guests")[0].blur();
      document.getElementsByName("pkg-per-person")[0].blur();
      this.props.calculateDiaper();
    }
    if (
      key === 13 &&
      this.state.eventDefaultValue === DC_Constants.TRIP_EVENT
    ) {
      document.getElementsByName("period")[0].blur();
      document.getElementsByName("weight")[0].blur();
      this.props.calculateDiaper();
    }
    if (e.target.value.length == 5) {
      e.preventDefault();
      // return true
    } else {
      let inputElement = e.target.value;
      // Not allowing entering '.' more than one
      if (key === 46 && inputElement.indexOf(e.key) !== -1) e.preventDefault();
      // Allowing '.' in input box
      if (
        key === 46 &&
        !(
          e.target.name === "number-of-guests" ||
          e.target.name === "period" ||
          e.target.name === "pkg-per-person"
        )
      )
        return true;
      // Handling below scenario for restricting alphabets
      if (key >= 97 && key <= 122) e.preventDefault();
      // For Preventing entering special Character
      if (key > 31 && (key < 48 || key > 57)) e.preventDefault();
      if (
        (e.target.name === "number-of-guests" || e.target.name === "period") &&
        key === 46
      )
        e.preventDefault();
      // Handling special case for character 'e'
      if (key === 101) e.preventDefault();
      else if (
        !(
          [8, 9, 13, 27, 46, 110, 190].indexOf(key) !== -1 ||
          (key == 65 && (e.ctrlKey || e.metaKey)) ||
          (key >= 35 && key <= 40) ||
          (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
          (key >= 96 && key <= 105)
        )
      )
        e.preventDefault();
    }
  };

  render() {
    let {
      eventDefaultValue,
      eventListOptions,
      showTripForm,
      showTeaPartyForm,
    } = this.state;
    // let removeBottomborderCss = {

    // }
    // if(eventDefaultValue === 'Trip'){
    //     removeBottomborderCss = {
    //         borderBottom : 'none'
    //     }
    // }
    return (
      <>
        <div className="event-dropdown">
          <label htmlFor="selectbox1">
            {this.props.componentData.eventDropDownTitle.value}
          </label>
          <div className="custom-select-dropdown">
            <div>
              <div className="select-box--box" ref={this.wrapperRef}>
                <div className="select-box--container">
                  <div className="select-box--selected-item">
                    {eventDefaultValue}
                  </div>
                  <div
                    className="select-box--arrow"
                    name="select-box--name"
                    onClick={this.dropDown}
                    onBlur={this.closeDropDown}
                  >
                    <span
                      name="drop-down-arrow"
                      className={`${
                        this.state.showItems
                          ? "select-box--arrow-up fa fa-angle-up"
                          : "select-box--arrow-down fa fa-angle-down"
                      }`}
                    ></span>
                  </div>
                  <div
                    style={{ display: this.state.showItems ? "block" : "none" }}
                    className="select-box--items"
                  >
                    {eventListOptions.map((item, index) => {
                      return (
                        <div
                          key={index}
                          onClick={() => this.selectItem(item.fields.eventName)}
                          className={
                            this.state.selectedItem === item.fields.eventName
                              ? "selected"
                              : ""
                          }
                        >
                          <strong>{item.fields.eventName.value}</strong>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <CustomDropDown {...this.props}/> */}
        </div>
        {showTeaPartyForm && (
          <div className="num-select">
            <div className="col-12 col-lg-6">
              <label htmlFor="guest">
                {this.props.componentData.guestTitle.value}
              </label>
              <input
                type="number"
                min="1"
                max="50"
                id="guest"
                className="form-control"
                name="number-of-guests"
                onChange={this.handleChange}
                onKeyPress={this.checkNumberOnly}
                value={this.state.numOfGuests}
                onBlur={this.validateValue}
                placeholder={
                  this.props.componentData.guestsPlaceholderText.value
                }
                maxLength={6}
              />
            </div>
            <div className="col-12 col-lg-6">
              <label htmlFor="packages">
                {this.props.componentData.packsPerPersonTitle.value}
              </label>
              <input
                type="number"
                min="1"
                max="25"
                id="packages"
                className="form-control"
                name="pkg-per-person"
                onChange={this.handleChange}
                onKeyPress={this.checkNumberOnly}
                value={this.state.pkgPerPerson}
                onBlur={this.validateValue}
                placeholder={
                  this.props.componentData.packsPerPersonPlaceholderText.value
                }
                maxLength={6}
              />
            </div>
          </div>
        )}
        {showTripForm && (
          <div className="num-select weight-area">
            <div className="col-12">
              <div className="weight-wrap">
                <label htmlFor="weight">
                  {this.props.componentData.babyWeightTitle.value}
                </label>
                <input
                  type="number"
                  step=".1"
                  min="1"
                  max="40"
                  id="guest"
                  className="form-control"
                  name="weight"
                  id="weight"
                  onChange={this.handleChange}
                  onKeyPress={this.checkNumberOnly}
                  value={this.state.weight}
                  onBlur={this.validateValue}
                  placeholder={
                    this.props.componentData.babyWeightPlaceholderText.value
                  }
                  maxLength={6}
                />
              </div>
              <div className="toggle-switch">
                <span>
                  {this.props.componentData.weightUnits[0].fields.name.value}
                </span>
                <label className="switch">
                  <input
                    type="checkbox"
                    value={this.weightUnits}
                    onChange={this.onToggle}
                  />
                  <span className="slider round"></span>
                </label>
                <span>
                  {this.props.componentData.weightUnits[1].fields.name.value}
                </span>
              </div>
              <div className="days-wrap">
                <label htmlFor="Period-days">
                  {this.props.componentData.travelDaysTitle.value}
                </label>

                <input
                  type="number"
                  min="1"
                  max="60"
                  id="packages"
                  className="form-control"
                  name="period"
                  id="period-days"
                  onChange={this.handleChange}
                  onKeyPress={this.checkNumberOnly}
                  value={this.state.period}
                  onBlur={this.validatePeriodValue}
                  placeholder={
                    this.props.componentData.travelDaysPlaceholderText.value
                  }
                  maxLength={6}
                />
              </div>
              {/* {this.state.showTripErrorLabel && <span class="period-error">value should be between 1 to 60</span>} */}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(DiaperLandingData);
